import { MS_PER_DAY } from './calendarDays';

/**
 * Both are shared by the customers table and the profile modal, which show the
 * same limit side by side and so must agree to the day.
 */
export const daysUntilExpiry = (timeout: string): number =>
  Math.ceil((new Date(timeout).getTime() - Date.now()) / MS_PER_DAY);

/** The -1 makes a timeout earlier today read 0 rather than 1. */
export const daysSinceExpiry = (timeout: string): number =>
  Math.ceil((Date.now() - new Date(timeout).getTime()) / MS_PER_DAY - 1);
